export function round(floatValue) {
    return Math.round(parseFloat(floatValue) * 100) / 100;
}

export function roundTo1Decimal(floatValue) {
    return Math.round(parseFloat(floatValue) * 10) / 10;
}

export const roundTo100 = (value) => Math.ceil(value / 100) * 100;
export const roundToNegative100 = (value) => Math.floor(value / 100) * 100;
export const roundTo10 = (value) => Math.ceil(value / 10) * 10;
export const roundTo50 = (value) => Math.ceil(value / 50) * 50;
export const roundToNegative10 = (value) => Math.floor(value / 10) * 10;
export const roundTo5 = (value) => Math.ceil(value / 5) * 5;

export const valueToMagnitude = (initialValue, initialUnit, fixedPlaces) => {
    if (initialValue == null) {
        return [initialValue];
    }

    let value = initialValue;
    let unit = initialUnit;

    const unitExponents = [
        [0, ''],
        [3, 'k'],
        [6, 'M'],
        [9, 'G'],
        [12, 'T'],
        [15, 'P'],
        [18, 'E'],
        [21, 'Y'],
    ];
    let oldExp = 0;
    if (unit) {
        const unitExponent = unitExponents.filter((item) => item[1] === unit.substr(0, 1));
        if (unitExponent.length === 1) {
            unit = unit.substr(1);
            value *= Math.pow(10, unitExponent[0][0]);
            oldExp = unitExponent[0][0];
        }
    }

    const sign = value < 0 ? -1 : 1;
    value = Math.abs(value);
    let idx = 0;
    for (let i = unitExponents.length - 1; i >= 0; i--) {
        if (value >= Math.pow(10, unitExponents[i][0])) {
            idx = i;
            break;
        }
    }

    const exp = unitExponents[idx][0];
    value /= Math.pow(10, exp);

    if (fixedPlaces !== undefined) {
        value = value.toFixed(fixedPlaces);
    }

    value *= sign;

    return [value, unitExponents[idx][1], unitExponents[idx][1] + unit, exp - oldExp];
};
